import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Models } from '../../models/global.models';

function createInitialState(): Models.SubjectPropertyInformationLeadForm {
  return <Models.SubjectPropertyInformationLeadForm>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'subject-property-information-lead-store' })
export class SubjectPropertyInformationLeadStore extends Store<Models.SubjectPropertyInformationLeadForm> {
  constructor() {
    super(createInitialState());
  }
}
